/** @jsxImportSource theme-ui */
import React from 'react';

import { ExportPrintAspectRatio } from 'utils/exportToPngHelpers';

import BdAspectRatio from 'components/_common/BdAspectRatio/BdAspectRatio';

const RiskOverviewCardPortraitContainer: React.FC = ({ children }) => {
  return (
    <div className="png-export" sx={{ width: '1038px', p: '72px', bg: 'white' }}>
      <BdAspectRatio ratio={ExportPrintAspectRatio}>
        <div sx={{ pb: '32px', px: '24px' }}>{children}</div>
      </BdAspectRatio>
    </div>
  );
};

export default RiskOverviewCardPortraitContainer;
